import { render, staticRenderFns } from "./bmcs.vue?vue&type=template&id=67964ec2&"
import script from "./bmcs.vue?vue&type=script&lang=js&"
export * from "./bmcs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports